export class IdentificationDocumentModel {

    public id: string;
    public type: number;
    public series: string;
    public number: string;
    public firstName: string;
    public lastName: string;
    public middleName: string;
    public birthDay: string;
    public birthPlaceStr: string;
    public issueDate: string;
    public issuedBy: string;
    public issueCountryId: number;
    public expiryDate: string;
    public note: string;
    public noteUpdatedBy: string;

    constructor(obj?: any) {
        this.id             = obj && obj.id             || '';
        this.type           = obj && obj.type           || null;
        this.series         = obj && obj.series         || '';
        this.number         = obj && obj.number         || '';
        this.firstName      = obj && obj.firstName      || '';
        this.lastName       = obj && obj.lastName       || '';
        this.middleName     = obj && obj.middleName     || '';
        this.birthDay       = obj && obj.birthDay       || '';
        this.birthPlaceStr  = obj && obj.birthPlaceStr  || '';
        this.issueDate      = obj && obj.issueDate      || '';
        this.issuedBy       = obj && obj.issuedBy       || '';
        this.issueCountryId = obj && obj.issueCountryId || '';
        this.expiryDate     = obj && obj.expiryDate     || '';
        this.note           = obj && obj.note           || '';
        this.noteUpdatedBy  = obj && obj.noteUpdatedBy  || '';
    }
}



// WEBPACK FOOTER //
// ./src/app/models/identification-document.model.ts